import { useHandleImageNavigation } from '@v2/pages/common/hooks/useHandleImageNavigation';
import { IMAGE_HANDLING_CONTEXT } from '@components/imageHandling/common';

import type { ThumbnailNavButtonProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ThumbnailNavButton';
import { ImageHandlingDisplayMode } from '@v2/components/imageHandling/types/types.d';

export interface UseManageThumbnailNavButtonParams extends Pick<ThumbnailNavButtonProps, 'documentRetrieveKey' | 'documentRetrieveId'> {}

export const useManageThumbnailNavButton = ({ documentRetrieveKey, documentRetrieveId }: UseManageThumbnailNavButtonParams) => {
  const { handleImageNavigation } = useHandleImageNavigation();

  const onPress = () =>
    handleImageNavigation({
      [IMAGE_HANDLING_CONTEXT[documentRetrieveKey]]: documentRetrieveId,
      keepState: true,
      imageHandlingMode: ImageHandlingDisplayMode.THUMBNAIL,
    });

  return { onPress };
};
